import { observer } from 'mobx-react';
import { COLUMN_COUNT } from '../Columns';

const ROWS = Array.from({ length: 5 }, (_, i) => i);
const CELLS = Array.from({ length: COLUMN_COUNT }, (_, i) => i);

function LoadingRows() {
  return (
    <tbody aria-hidden="true">
      {ROWS.map((row) => (
        <tr key={row} className="border-b border-border last:border-b-0">
          {CELLS.map((cell) => (
            <td key={cell} className="px-4 py-4">
              <div className="h-4 w-3/4 animate-pulse rounded bg-muted" />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}

export default observer(LoadingRows);
